import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import UserDetailsModel from "../../models/user-security/userdetails-model";


const url = getEndPoint(API_END_POINT.ADMIN) +"/api/UserDetails/GetAllUserDetails";// //{/api/UserType/GetAllUserType}`)  //// "https://localhost:7054/api/UserType/GetAllUserType";
export const useGetUserDetails = createQuery<
  UserDetailsModel[],
  null,
  AxiosError
>({
  queryKey: ["keyUserDetailslist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
   // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});